module.exports = {"id":"224411","name":"Gonçalo Guedes","rating":"79","photo":"./data/images/photos/0/224411.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["MG","AG","BU","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GoncaloGuedes0.json
// module id = 1618
// module chunks = 0